import React from "react";
import Button from "../../shared/Button/Button";
import styles from "./BackgroundImageWithTextButtonRightImageLeft.module.scss";
import Link from "next/link";
import { useRouter } from "next/router";
import thirdBg from "../../../assets/images/third-bg.png";

export default function BackgroundImageWithTextButtonRightImageLeft({
  primaryText = "",
  secondaryText = "",
  buttonColor = "black",
  buttonShape = "round",
  footerLinks,
}) {
  const { locale } = useRouter();
  const isRtl = locale === "ar";
  const dir = isRtl ? "rtl" : "ltr";
  const ctaText = locale === "ar" ? "تواصل معنا" : "Contact us";

  return (
    <div className={styles.container}>
      <div
        className={styles.background}
        dir={dir}
      >
        <div className={styles["overlay-text"]}>
          <div className={styles["text-content"]}>
            <h3 className={styles["primary-text"]}>{primaryText}</h3>
            <p className={styles["secondary-text"]}>{secondaryText}</p>
          </div>
          <Link href="/contactus" legacyBehavior>
            <a className={styles["cta-link"]}>
              {ctaText}
              <div className={styles["icon-circle"]}>
                <svg
                  style={{ transform: isRtl ? "none" : "scaleX(-1)" }}
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M3.53577 3.53556L14.1424 14.1422"
                    stroke="black"
                    strokeWidth={1.5}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M3.53553 10.6066L3.53553 3.53553L10.6066 3.53553"
                    stroke="black"
                    strokeWidth={1.5}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
            </a>
          </Link>
        </div>
      </div>
    </div>
  );
}
